import { render } from "./BoardMembersAll.vue?vue&type=template&id=27c2eb5e&scoped=true"
import script from "./BoardMembersAll.vue?vue&type=script&lang=js"
export * from "./BoardMembersAll.vue?vue&type=script&lang=js"

import "./BoardMembersAll.vue?vue&type=style&index=0&id=27c2eb5e&scoped=true&lang=css"

import exportComponent from "D:\\javascript\\storyticket-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c2eb5e"]])

export default __exports__